<template>
  <!-- 汇款人别名表 — 입금자명 → 사업자(营业执照) 후보 표 보기·고치기·끄기·엑셀 올리기(관리자만 · 판 #670 C).
       은행 대조는 이 표를 «후보»로만 쓴다(자동 확정 없음). 사업자번호는 끝 4자리만 보인다.
       서버 /api/coupass/depositorAlias/* · 규칙 inventory-services/depositor-alias.js -->
  <b-modal :visible="value" @change="v => $emit('input', v)" size="xl" hide-footer
           title="📇 汇款人别名表 (입금자 별칭 표)" body-class="pt-2" @show="load(0)">
    <div class="d-flex flex-wrap align-items-center mb-2">
      <input v-model="q" class="form-control form-control-sm mr-2" style="max-width: 220px;" placeholder="搜索汇款人(입금자명 검색)" @keyup.enter="load(0)">
      <select v-model="status" class="form-control form-control-sm mr-2" style="max-width: 160px;" @change="load(0)">
        <option value="">全部(전체)</option>
        <option value="active">使用中(사용)</option>
        <option value="disabled">已停用(끔)</option>
      </select>
      <b-button size="sm" variant="outline-primary" class="mr-2" @click="load(0)">查询(조회)</b-button>
      <b-spinner v-if="loading" small class="mr-2"></b-spinner>
      <div class="ml-auto">
        <b-button size="sm" variant="outline-success" class="mr-2" @click="startNew">+ 新增(새로)</b-button>
        <label class="btn btn-sm btn-outline-secondary mb-0">
          ⬆ 上传Excel(엑셀 올리기 · 업체/입금자명/사업자번호/상호/대표/이메일)
          <input type="file" accept=".xls,.xlsx" class="d-none" @change="onFile">
        </label>
      </div>
    </div>
    <p class="small text-muted mb-2">
      只作为候选(후보로만 — 대조가 자동 확정하지 않음) · 停用=不再作为候选(끄기 = 대조 후보에서 빠짐 · 줄은 남음) · 营业执照只显示后4位(사업자번호 끝 4자리만).
    </p>
    <div v-if="error" class="alert alert-danger py-1 small">{{ error }}</div>

    <div v-if="importStats" class="alert alert-info py-1 small">
      {{ importFile }} · 将导入(적재 대상) {{ importStats.적재대상 }} · 排除(제외) {{ importStats.제외_입금자명빈칸 + importStats.제외_사업자번호빈칸 + importStats.제외_사업자번호형식 }}
      · 同名不同执照(동명 다른 사업자) {{ importStats.동명_서로다른사업자_후보표시 }}
      <span v-if="importResult"> · 新增(신규) {{ importResult.신규 }} · 已有跳过(기존 건너뜀) {{ importResult.기존_건너뜀 }}</span>
      <b-button v-else size="sm" variant="primary" class="ml-2 py-0" :disabled="saving || !importStats.적재대상" @click="applyImport">导入(적재)</b-button>
    </div>

    <div v-if="edit" class="border rounded p-2 mb-2 small">
      <div class="form-row">
        <div class="col-md-3"><label class="mb-0">汇款人(입금자명)</label><input v-model="edit.rawName" class="form-control form-control-sm"></div>
        <div class="col-md-2"><label class="mb-0">营业执照(사업자번호) <small v-if="edit._id" class="text-muted">…{{ edit.bizLast4 }}</small></label>
          <input v-model="edit.businessLicenseKey" class="form-control form-control-sm" :placeholder="edit._id ? '改时才填(바꿀 때만)' : '10位(10자리)'"></div>
        <div class="col-md-2"><label class="mb-0">货主标签(업체)</label><input v-model="edit.companyLabel" class="form-control form-control-sm"></div>
        <div class="col-md-2"><label class="mb-0">商号(상호)</label><input v-model="edit.recipientName" class="form-control form-control-sm"></div>
        <div class="col-md-1"><label class="mb-0">代表(대표)</label><input v-model="edit.recipientRep" class="form-control form-control-sm"></div>
        <div class="col-md-2"><label class="mb-0">邮箱(이메일) <small v-if="edit._id" class="text-muted">{{ edit.emailCount }}个</small></label>
          <input v-model="edit.emails" class="form-control form-control-sm" :placeholder="edit._id ? '改时才填(바꿀 때만)' : ''"></div>
      </div>
      <div class="mt-2">
        <b-button size="sm" variant="success" class="mr-2" :disabled="saving" @click="save">保存(저장)</b-button>
        <b-button size="sm" variant="outline-secondary" @click="edit = null">取消(취소)</b-button>
      </div>
    </div>

    <!-- 좁은 폭(폰)에선 칸이 글자 하나씩 꺾이지 않게 표 최소 폭을 두고 옆으로 민다 -->
    <div class="table-responsive" style="max-height: 58vh;">
      <table class="table table-sm table-bordered small mb-0" style="min-width: 1030px; table-layout: fixed;">
        <thead class="thead-light" style="position: sticky; top: 0; z-index: 1;">
          <tr>
            <th style="width: 150px;">汇款人<br><small>(입금자명)</small></th>
            <th style="width: 90px;">营业执照<br><small>(사업자번호 끝4)</small></th>
            <th style="width: 120px;">货主标签<br><small>(업체)</small></th>
            <th style="width: 190px;">商号·代表<br><small>(상호·대표)</small></th>
            <th style="width: 60px;">邮箱<br><small>(메일 수)</small></th>
            <th style="width: 90px;">状态<br><small>(상태)</small></th>
            <th style="width: 160px;">修改<br><small>(고친 때·누가)</small></th>
            <th style="width: 170px;"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="r in rows" :key="r._id" :style="r.status === 'disabled' ? 'opacity: .5;' : ''">
            <td>{{ r.rawName }}</td>
            <td class="text-nowrap">…{{ r.bizLast4 }}</td>
            <td>{{ r.companyLabel }}</td>
            <td>{{ r.recipientName }}<span v-if="r.recipientRep"> · {{ r.recipientRep }}</span></td>
            <td class="text-right">{{ r.emailCount }}</td>
            <td><b-badge :variant="r.status === 'active' ? 'success' : 'secondary'">{{ r.status === 'active' ? '使用中(사용)' : '已停用(끔)' }}</b-badge></td>
            <td><small>{{ when(r.updatedAt) }} · {{ r.updatedBy }}</small>
              <div v-if="r.history.length > 1" class="text-muted"><small>{{ r.history.slice(1).map(h => h.field).join(', ') }}</small></div></td>
            <td class="text-nowrap">
              <b-button size="sm" variant="outline-primary" class="py-0 px-1 mr-1" @click="startEdit(r)">改(고침)</b-button>
              <b-button size="sm" :variant="r.status === 'active' ? 'outline-danger' : 'outline-success'" class="py-0 px-1" :disabled="saving" @click="toggle(r)">
                {{ r.status === 'active' ? '停用(끄기)' : '启用(켜기)' }}</b-button>
            </td>
          </tr>
          <tr v-if="!rows.length && !loading"><td colspan="8" class="text-center text-muted">无(없음)</td></tr>
        </tbody>
      </table>
    </div>
    <div class="d-flex align-items-center mt-2 small">
      <span class="text-muted">共(총) {{ total }}</span>
      <div class="ml-auto">
        <b-button size="sm" variant="outline-secondary" class="mr-1" :disabled="page === 0" @click="load(page - 1)">‹</b-button>
        <span>{{ page + 1 }} / {{ Math.max(1, Math.ceil(total / 50)) }}</span>
        <b-button size="sm" variant="outline-secondary" class="ml-1" :disabled="(page + 1) * 50 >= total" @click="load(page + 1)">›</b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import axios from 'axios';
import * as XLSX from 'xlsx';

const API = '/api/coupass/depositorAlias/';

export default {
  name: 'DepositorAliasModal',
  props: { value: { type: Boolean, default: false } },
  data() {
    return { q: '', status: '', rows: [], total: 0, page: 0, loading: false, saving: false, error: '', edit: null, importFile: '', importRows: [], importStats: null, importResult: null };
  },
  methods: {
    when(t) { return t ? new Date(t).toLocaleString() : ''; },
    async call(path, body) {
      const res = await axios.post(API + path, body);
      if (res.data.요청결과 !== '성공') throw new Error((res.data.error && res.data.error.errorMessage) || '실패');
      return res.data;
    },
    async load(page) {
      this.loading = true; this.error = '';
      try {
        const d = await this.call('list', { q: this.q, status: this.status, page });
        this.rows = d.rows; this.total = d.total; this.page = d.page;
      } catch (e) {
        console.error('[别名表] 조회 실패:', e);
        this.error = '查询失败(조회 실패): ' + (e.message || e);
      } finally { this.loading = false; }
    },
    startNew() { this.edit = { _id: '', rawName: '', businessLicenseKey: '', companyLabel: '', recipientName: '', recipientRep: '', emails: '' }; },
    // 고칠 때 사업자번호·메일은 화면에 원문이 없다 — 칸을 채운 때만 바꾼다
    startEdit(r) { this.edit = { ...r, businessLicenseKey: '', emails: '' }; },
    async save() {
      const e = this.edit; this.saving = true; this.error = '';
      try {
        if (!e._id) {
          await this.call('save', { rawName: e.rawName, businessLicenseKey: e.businessLicenseKey, companyLabel: e.companyLabel, recipient: { name: e.recipientName, rep: e.recipientRep, emails: e.emails } });
        } else {
          const patch = { rawName: e.rawName, companyLabel: e.companyLabel };
          if (e.businessLicenseKey.trim()) patch.businessLicenseKey = e.businessLicenseKey;
          const old = this.rows.find(r => r._id === e._id) || {};
          if (e.emails.trim() || e.recipientName !== old.recipientName || e.recipientRep !== old.recipientRep) {
            if (!e.emails.trim() && old.emailCount) { this.error = '改商号·代表时请重新填写邮箱(상호·대표를 고칠 때는 메일도 다시 넣어 주세요)'; return; }
            patch.recipient = { name: e.recipientName, rep: e.recipientRep, emails: e.emails };
          }
          await this.call('save', { _id: e._id, updatedAt: e.updatedAt, patch });
        }
        this.edit = null;
        await this.load(this.page);
      } catch (err) {
        console.error('[别名表] 저장 실패:', err);
        this.error = '保存失败(저장 실패): ' + (err.message || err);
      } finally { this.saving = false; }
    },
    async toggle(r) {
      const to = r.status === 'active' ? 'disabled' : 'active';
      if (to === 'disabled' && !confirm(`停用「${r.rawName}」？不再作为到账核对候选。\n「${r.rawName}」을 끕니다. 입금 대조 후보에서 빠집니다. 계속할까요?`)) return;
      this.saving = true; this.error = '';
      try {
        await this.call('save', { _id: r._id, updatedAt: r.updatedAt, patch: { status: to } });
        await this.load(this.page);
      } catch (e) {
        console.error('[别名表] 상태 변경 실패:', e);
        this.error = '修改失败(바꾸기 실패): ' + (e.message || e);
      } finally { this.saving = false; }
    },
    // 엑셀은 화면에서 읽어 행 배열만 보낸다(첫 줄 = 머리 · 서버가 plan() 으로 건수 미리보기)
    async onFile(ev) {
      const file = ev.target.files && ev.target.files[0];
      ev.target.value = '';
      if (!file) return;
      this.error = ''; this.importFile = file.name; this.importStats = null; this.importResult = null;
      try {
        const w = XLSX.read(await file.arrayBuffer(), { type: 'array' });
        this.importRows = XLSX.utils.sheet_to_json(w.Sheets[w.SheetNames[0]], { header: 1, defval: '' }).slice(1);
        const d = await this.call('import', { rows: this.importRows });
        this.importStats = d.stats;
      } catch (e) {
        console.error('[别名表] 엑셀 읽기 실패:', e);
        this.error = '文件读取失败(파일 읽기 실패): ' + (e.message || e);
      }
    },
    async applyImport() {
      if (!confirm(`导入 ${this.importStats.적재대상} 行？已有的不覆盖。\n${this.importStats.적재대상}줄을 적재합니다. 이미 있는 줄은 덮지 않습니다. 계속할까요?`)) return;
      this.saving = true; this.error = '';
      try {
        const d = await this.call('import', { rows: this.importRows, apply: true });
        this.importResult = d.결과;
        await this.load(0);
      } catch (e) {
        console.error('[别名表] 적재 실패:', e);
        this.error = '导入失败(적재 실패): ' + (e.message || e);
      } finally { this.saving = false; }
    }
  }
};
</script>
